import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to get the most out of yourself.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>We only use 10% of our brain…</p>
                                            <div className="border_subtitle">Maximising our mental ability</div>
                                            <p>This common saying has been exposed as largely a myth by
                                                contemporary research. Instead, it
                                                has been shown that our brains tend to work in bursts which can
                                                be using a wide array of
                                                different sections at any one time. These bursts become more
                                                coordinated as we repeat certain
                                                tasks and actions. This is the basis for what psychologists call
                                                the ‘practice effect’. This explains
                                                how practising tasks gets the best out of our brains. As well as
                                                our experience, understanding our
                                                motivations and talents is vital to unleashing our full
                                                potential at work. Psychologists who study
                                                people at work have consistently found that if people feel that
                                                their motives line up with the type
                                                of work they are doing, then they are both happier and more
                                                successful in their careers. This is
                                                called the actualising tendency.</p>
                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">Believe you can do it</div>
                                                <p>In a recent study, Hoffman and Spatariu<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>3</sup></a> tested
                                                    the impact of ability and self belief on
                                                    problem-solving success. They tested 81 students in mental
                                                    multiplication, as well as
                                                    recording their confidence levels. They gave the
                                                    participants a number of calculations, each
                                                    one becoming more difficult. In a twist, they gave half the
                                                    students so-called ‘metacognitive
                                                    prompts’ during the testing; for example, the computer
                                                    screen would flash up prompts like
                                                    ‘What steps are you using to solve these problems?’.</p>
                                                <p>They found that the highest-performing students were those
                                                    who had higher ability and
                                                    self belief. The metacognitive prompting helped with speed
                                                    and accuracy only with the
                                                    harder sums.</p>
                                                <div className="uiheading"><p>The main implication of this study
                                                    is that it is a combination of both self-belief and ability
                                                    which aids effective problem solving.</p></div>
                                            </div>

                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}